import { defineFetch } from 'resift';

const makeGetLatestSourceFile = defineFetch({
  displayName: 'Gets latest source file from source id',
  make: (sourceId, type = 'data') => ({
    request: () => ({ http }) =>
      http({
        method: 'GET',
        route: `/source-files/latest?sourceId=${sourceId}&type=${type}`,
      }),
  }),
});

export default makeGetLatestSourceFile;
